import { EntitySwitch, isComponentType } from '@backstage/plugin-catalog';

import { defaultComponentEntityPage } from '../defaultComponentEntityPage/defaultComponentEntityPage';
import { libraryEntityPage } from '../libraryEntityPage/libraryEntityPage';
import { serviceEntityPage } from '../serviceEntityPage/serviceEntityPage';
import { websiteEntityPage } from '../websiteEntityPage/websiteEntityPage';

export const componentPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('library')}>
      {libraryEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('service')}>
      {serviceEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>
      {websiteEntityPage}
    </EntitySwitch.Case>

    <EntitySwitch.Case>{defaultComponentEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
